import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "M-Auto DialogContainer" }
const _hoisted_3 = {
  class: "DialogBody",
  style: {"width":"auto","max-width":"90vw"}
}
const _hoisted_4 = { class: "DialogSectionTitle F1_5em" }
const _hoisted_5 = { class: "DialogSection F_75em" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "CookiesRowSpacer" }, null, -1)
const _hoisted_7 = { class: "DialogSection" }
const _hoisted_8 = { class: "CookiesRow F-C2" }
const _hoisted_9 = { class: "M-Auto F-Bold" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DialogDisabler = _resolveComponent("DialogDisabler")!
  const _component_CookiesTable = _resolveComponent("CookiesTable")!
  const _component_CookiesNormalInput = _resolveComponent("CookiesNormalInput")!

  return (_openBlock(), _createElementBlock("div", {
    id: 'CookiesDialog_' + _ctx.DialogIndex,
    class: "CookiesDialogdBody"
  }, [
    (_ctx.Saving || _ctx.Loading.length)
      ? (_openBlock(), _createBlock(_component_DialogDisabler, { key: 0 }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.Translate('Are you sure all items are checked correctly?')), 1),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_CookiesTable, {
            style: {"max-width":"100%"},
            CookiesInvalidInput: _ctx.TransferItems.length < 1,
            ErrorData: _ctx.ErrorsVisibilty && _ctx.TransferItems.length < 1,
            class: "Shadow1",
            TableSettings: _ctx.TableSettings,
            CookiesData: _ctx.$store.state.CookiesConfig[`Branch_${_ctx.$store.state.BranchManagment.CurrentBranch?.ID}_AlwaysCombineItems`] ? _ctx.CombinedItems : _ctx.TransferItems
          }, null, 8, ["CookiesInvalidInput", "ErrorData", "TableSettings", "CookiesData"])
        ]),
        _hoisted_6,
        _createElementVNode("div", _hoisted_7, [
          ((_ctx.DialogData?.Data.Type === 'Import'))
            ? (_openBlock(), _createBlock(_component_CookiesNormalInput, {
                key: 0,
                Placeholder: _ctx.Translate('Driver'),
                Res: 'ExportVehicleDriver'
              }, null, 8, ["Placeholder"]))
            : _createCommentVNode("", true),
          ((_ctx.DialogData?.Data.Type !== 'ExternalImport'))
            ? (_openBlock(), _createBlock(_component_CookiesNormalInput, {
                key: 1,
                Placeholder: _ctx.Translate('Vehicle No'),
                Res: 'ExportVehicleNumber'
              }, null, 8, ["Placeholder"]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("button", {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.go(-1))),
              style: _normalizeStyle('background: ' + _ctx.Theme.Shade3),
              class: "F-Bold CookiesButton DialogFooterButton"
            }, _toDisplayString(_ctx.Translate('Cancel')), 5),
            _createElementVNode("button", {
              class: _normalizeClass([_ctx.NotEnoughSpace || (_ctx.DialogData?.Data.Type !== 'ExternalImport' && (!_ctx.MEMRead('ExportVehicleNumber') || _ctx.MEMRead('ExportVehicleNumber') === '') || _ctx.Saving) ? 'Disabled' : '', "F-Bold CookiesButton DialogFooterButton BGMain"]),
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.Confirm()))
            }, _toDisplayString(_ctx.Translate('Confirm')), 3)
          ])
        ])
      ])
    ])
  ], 8, _hoisted_1))
}